/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';


/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        // signUpSignIn: 'B2C_1_msc-dev'
        signUpSignIn: `${process.env.REACT_APP_API_B2C_SIGNUPSIGNIN}`,
        forgotPassword: `${process.env.REACT_APP_API_B2C_PASSWORDRESET}`
    },
    authorities: {
        signUpSignIn: {
            // authority: 'https://mscsecurityb2c.b2clogin.com/mscsecurityb2c.onmicrosoft.com/B2C_1_msc-dev',
            authority: `${process.env.REACT_APP_API_B2C_AUTHORITY}`,
        },
        forgotPassword: {
          authority: `${process.env.REACT_APP_API_B2C_AUTHORITY_PASSSRESET}`,
        }
    },
    // authorityDomain: 'mscsecurityb2c.b2clogin.com'
    authorityDomain: `${process.env.REACT_APP_API_B2C_AUTHORITY_DOMAIN}`
}


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        // clientId: '226d00bd-1ed0-4dba-9613-e87ee7611ebb', // This is the ONLY mandatory field that you need to supply.
        clientId: `${process.env.REACT_APP_API_B2C_CLIENT_ID}`, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        // redirectUri: 'https://icy-sky-09e31d500.2.azurestaticapps.net', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        redirectUri: `${process.env.REACT_APP_API_B2C_REDIRECT_URL}`, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        // postLogoutRedirectUri: 'https://icy-sky-09e31d500.2.azurestaticapps.net', // Indicates the page to navigate after logout.
        postLogoutRedirectUri: `${process.env.REACT_APP_API_B2C_REDIRECT_URL}`, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    apiHello: {
        // endpoint: 'https://icy-sky-09e31d500.2.azurestaticapps.net',
        endpoint: `${process.env.REACT_APP_API_B2C_REDIRECT_URL}`,
        // scopes: ['https://mscsecurityb2c.onmicrosoft.com/mscapi/msc.owner'], // e.g. api://xxxxxx/access_as_user
        scopes: [`${process.env.REACT_APP_API_B2C_SCOPES}`], // e.g. api://xxxxxx/access_as_user
    },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
 export const loginRequest = {
    scopes: [...protectedResources.apiHello.scopes]
};

